"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Logo = function Logo(props) {
  var classes = (0, _classnames["default"])("logo-component", props.className);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: props.url,
    style: _objectSpread({
      paddingLeft: props.padding
    }, props.style),
    width: props.width,
    height: props.height,
    alt: props.alt,
    onClick: props.onClick
  }));
};

Logo.propTypes = {
  url: _propTypes["default"].string,
  padding: _propTypes["default"].string,
  className: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  alt: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onClick: _propTypes["default"].func
};
Logo.defaultProps = {
  style: {},
  url: "",
  className: "",
  padding: ""
};
var _default = Logo;
exports["default"] = _default;